import { z } from 'zod';
/**
 * Admin-Audit-Log (AUDIT_VIEW_ALL): Auswertungs-Screen über die append-only
 * Hash-Kette. Read-only-Contract — Schreiben passiert ausschließlich über den
 * audit()-Helper im Backend.
 */
export const auditLogQuery = z.object({
    /** Filter: nur Einträge dieses Users (null-User = System/Token-Aktionen). */
    userId: z.coerce.number().int().positive().optional(),
    /**
     * Volltextsuche über Aktion UND Entität — Teiltreffer, case-insensitive.
     *
     * Ersetzt in der UI die getrennten Felder: es gibt inzwischen weit über
     * achtzig Aktionstypen, und wer „abweichung" sucht, weiß nicht, ob die
     * Aktion `project.deviation.decide` oder `project.deviations.submit` heißt.
     * `action`/`entity` bleiben als exakte API-Filter bestehen.
     */
    search: z
        .string()
        .trim()
        .max(100)
        .optional()
        .transform((v) => (v ? v : undefined)),
    /** Filter: Aktion beginnt mit … (z. B. 'project.' oder 'user.update'). */
    action: z.string().trim().min(1).max(100).optional(),
    /** Filter: Entität (z. B. 'project', 'user', 'document'). */
    entity: z.string().trim().min(1).max(50).optional(),
    /** Filter: konkrete Entitäts-ID (String, wie gespeichert). */
    entityId: z.string().trim().min(1).max(50).optional(),
    /** Zeitraum (ISO 8601). */
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    limit: z.coerce.number().int().positive().max(200).default(50),
    offset: z.coerce.number().int().nonnegative().default(0),
});
export const auditLogEntry = z.object({
    /** BigInt in der DB — als String serialisiert (IDs > 2^53 sicher). */
    id: z.string(),
    userId: z.number().int().nullable(),
    userName: z.string().nullable(),
    action: z.string(),
    entity: z.string(),
    entityId: z.string(),
    diff: z.unknown().nullable(),
    ip: z.string().nullable(),
    createdAt: z.string().datetime(),
});
export const auditLogResponse = z.object({
    items: z.array(auditLogEntry),
    total: z.number().int().nonnegative(),
    limit: z.number().int().positive(),
    offset: z.number().int().nonnegative(),
});
